<!--// 二次封装element-ui 的table组件-->
<!--// props中 tableData为父组件接口获取数据后传来-->
<!--//         configData为配置表格列内容例如（是否固定，宽度设置等）-->
<template v-if="tableData.length > 0">
<el-table :data="tableData" tooltip-effect="dark" style="width: 100%" :max-height="height" ref="multipleTable"
	:stripe="isStripe" :size="size" :border="border" :show-header="headShow" row-key="name" default-expand-all
	:tree-props="{ children: 'children', hasChildren: 'hasChildren' }" @selection-change="handleSelectionChange"
	@select="selectChange" :span-method="spanMethod" v-loading="loading">
	<el-table-column v-if="configData.length > 0 && indexShow" align="center" type="index" fixed label="序号"
		:index="indexMethod" />
	<template v-for="(item, index) in configData">
		<template v-if="item.type !== 'handleList'">
			<!-- 判断item.value是否为数组，当为数组时需将数组拼接显示 -->
			<template v-if="Array.isArray(item.value)">
				<el-table-column :key="index" :label="item.label" align="center" :width="item.width ? item.width : ''"
					:fixed="item.fixed ? item.fixed : false" show-overflow-tooltip>
					<template slot-scope="scope">
						<template v-for="(con, ind) in item.value">
							<span :key="ind">{{ scope.row[con] }}</span>
						</template>
					</template>
				</el-table-column>
			</template>
			<template v-else>
				<template v-if="item.type === 'selection'">
					<el-table-column v-if="selectionShow" :key="index" :label="item.label" :align="item.align"
						type="selection" :width="item.width ? item.width : ''"
						:fixed="item.fixed ? item.fixed : false"></el-table-column>
				</template>
				<template v-else>
					
					<el-table-column :key="index" :type="item.expand" :label="item.label" :align="item.align" :resizable="resizable" 
						:width="item.width ? item.width : ''" :fixed="item.fixed ? item.fixed : false"
						:show-overflow-tooltip="item.showOverflow || false">
						<template slot-scope="scope">
							<!--time return YYYY-MM-DD-->
							<template v-if="item.type === 'date'">
								{{ scope.row[item.value] | timeFormatMmd }}
							</template>
							<template v-else-if="item.type === 'time'">
								{{ scope.row[item.value] | timeFormatMmdTime }}
							</template>
							<!--timeDate return YYYY-MM-DD HH:mm:ss-->
							<template v-else-if="item.type === 'timeDate'">
								{{ scope.row[item.value] | timeFormat }}
							</template>
							<!--内容展示 icon-->
							<template v-else-if="item.type === 'icon'">
								<el-tooltip class="item" effect="dark" :content="item.iconName" placement="bottom">
									<el-button type="text" :icon="item.icon" class="iconPageInfo"></el-button>
								</el-tooltip>
							</template>
							<!--内容展示 图片-->
							<template v-else-if="item.type === 'img'">
								<el-image class="flexCenter" :src="scope.row[item.value]"
									style="width: 100px;height: 100px;display: flex;align-items: center;justify-content: center;margin: auto;"
									:preview-src-list="item.dontLookImg ? [] : ([scope.row[item.value]] || [])">
									<div slot="error" class="image-slot">暂无图片</div>
								</el-image>
							</template>
							<!--内容展示 传过来的方法-->
							<template v-else-if="item.type === 'other'">
								{{ item.other(scope.row) }}
							</template>
							<!--内容展示 传过来的json列表-->
							<template v-else-if="item.objList">
								{{ item.objList[scope.row[item.value]] }}
							</template>
							<!--内容展示 需要复制内容-->
							<template v-else-if="item.isCopy">
								<span title="点击复制" v-clipboard:copy="scope.row[item.value]"
									v-clipboard:success="copy.onCopy" v-clipboard:error="copy.onError"
									style="cursor: copy;">{{ scope.row[item.value] || '' }}</span>
							</template>
							<!--内容展示 合并单元格-->
							<template v-else-if="item.Array === 'Array'">
								<div class="moreDataInList" v-for="(i, j) in scope.row[item.arrayTitle]" :key="j">
									<span>{{ item.value === 'isArray' ? item.other(i) : i[item.value] }}</span>
									<div class="he"
										v-show="scope.row[item.arrayTitle] && !(j === scope.row[item.arrayTitle].length - 1)">
									</div>
								</div>
							</template>
							<template v-else-if="item.type === 'switch'">
								<el-switch v-model="scope.row[item.value]" active-text="是" inactive-text="否">
								</el-switch>
							</template>
							<!-- 价格 -->
							<template v-else-if="item.type === 'price'">
								<span :style="item.style.css">
									{{ scope.row[item.value] !== '' ? item.style.currency : '' }} {{
										scope.row[item.value] | NumFormat
									}}
								</span>
							</template>
							<!-- 插槽内容全部自定义 -->
							<template v-else-if="item.type === 'custom' && !item.expand">
								<slot :name="item.customName" :data="scope.row"></slot>
							</template>
							<template v-else-if="item.type === 'custom' && item.expand">
								<slot :name="item.customName"  :data="scope.row"></slot>
							</template>
							<!--内容展示 无特殊情况，原样返回-->
							<template v-else>
								<span v-html="scope.row[item.value]"></span>
							</template>
						</template>
					</el-table-column>
				</template>
			</template>
		</template>
		<template v-else>
			<el-table-column :key="index" :label="item.label" align="center" :width="item.width ? item.width : ''"
				:fixed="item.fixed ? item.fixed : false">
				<template slot-scope="scope">
					<template v-for="(button, i) in item.buttonList">
						<template v-if="button.show || (button.showCondition && button.showCondition(scope.row))">
							<el-button :key="i" v-if="button.showText" type="text" size="mini" :icon="button.icon"
								class="iconPageInfo_text" :style="button.btnStyle"
								:disabled="button.condition && button.condition(scope.row)"
								@click="handleClick(button.event, scope.row, button.text, scope.$index)">
								{{ button.label }}
							</el-button>
						</template>
						<template v-if="button.showCondition && button.showCondition(scope.row)">
							<el-tooltip v-if="!button.showText" class="item" effect="dark" :content="button.label"
								placement="bottom" :key="i">
								<el-button type="text" size="mini" :icon="button.icon" class="iconPageInfo"
									:style="button.btnStyle" :disabled="button.condition && button.condition(scope.row)"
									@click="handleClick(button.event, scope.row, button.text, scope.$index)">
								</el-button>
							</el-tooltip>
						</template>
					</template>
				</template>
			</el-table-column>
		</template>
	</template>
</el-table>
</template>
<script>
const setData = {
	type: Array,
	default: () => []
};
export default {
	name: 'TableTotal',
	props: {
		// 表格数据
		tableData: setData,
		// 表格配置
		configData: setData,
		// 表格的高度
		height: {
			type: Number,
			default: () => 500
		},
		// 是否显示表头
		headShow: {
			type: Boolean,
			default: () => true
		},
		// 是否开启序号
		indexShow: {
			type: Boolean,
			default: true
		},
		// 配置表格大小
		size: {
			type: String,
			default: 'small'
		},
		// 配置表格是否有边框
		border: {
			type: Boolean,
			default: true
		},
		// 对应列是否可以通过拖动改变宽度
		resizable: {
			type: Boolean,
			default: true
		},
		// 是否为斑马纹 table
		isStripe: {
			type: Boolean,
			default: false
		},
		// 是否为显示选择框
		selectionShow: {
			type: Boolean,
			default: true
		},
		// 合并行或列的计算方法
		spanMethod: {
			type: Function
		},
		page: {
			type: Number,
			default: 1
		},
		// 配置表格loading
		loading: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		tableData() {
			this.$nextTick(() => {
				this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
			});
		}
	},
	data() {
		return {
			multipleSelection: []
		};
	},
	filters: {
		// 金额显示.00格式
		NumFormat: function (value) {
			if (!['[object Number]', '[object String]'].includes(Object.prototype.toString.call(value))) {
				return value
			}
			let num = value.toString().replace(/^(\d+)(\.\d+)?$/g, (big, ...args) => {
				let [a, b] = args
				if (!b) b = '.'
				while (b.length <= 2) {
					b += '0'
				}
				return a + b
			})
			return num;
		},
	},
	methods: {
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
			this.$emit('handleSelectionChange', val)
		},
		selectChange(val) {
			this.multipleSelection = val;
			this.$emit('selectChange', val)
		},
		// 派发按钮点击事件
		handleClick(event, data, text, index) {
			this.$emit('handleClick', event, data, text, index);
		},
		// 分页序号
		indexMethod(index) {
			return index + 1;
		}
	}
};
</script>

<style lang="scss" scoped>
.el-table {

	> ::v-deep .el-table__header-wrapper {
		thead {
			.cell {
				text-align: center;
			}
		}
	}

	::v-deep .el-table__body-wrapper {
		tbody {
			.el-table-column--selection {

				> .cell {
					padding-left: 14px;
					text-align: center;
				}
			}
		}
	}
}
.iconPageInfo {
	font-size: 18px;
	margin-right: 10px;
}

.iconPageInfo_text {
	font-size: 14px;
	margin-right: 10px;
}

.moreDataInList {
	padding: 5px 0;

	.he {
		width: 100%;
		height: 1px;
		background: #EBEEF5;
		position: absolute;
		left: 0;
	}
}
</style>